/**
 * Requirements Block Configuration
 *
 * Registry config for the mandatory requirements (SKA-krav) block type.
 */

import { ClipboardCheck } from "lucide-react";
import { RequirementsBlock } from "@/canvas/components/blocks/RequirementsBlock";
import type { BlockConfig } from "../types";

export const requirementsBlockConfig: BlockConfig<"requirements"> = {
  type: "requirements",
  component: RequirementsBlock,
  icon: ClipboardCheck,
  iconClassName: "text-emerald-600",
  label: "canvas.blockTypes.requirements",
  defaultContent: () => ({ items: [] }),
  showInAddBlockMenu: true,
};
